import { render, staticRenderFns } from "./commonOrderDetail.vue?vue&type=template&id=5f131596&scoped=true"
import script from "./commonOrderDetail.vue?vue&type=script&lang=js"
export * from "./commonOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f131596",
  null
  
)

export default component.exports